import { render, staticRenderFns } from "./ViewPerson.vue?vue&type=template&id=e30f5c16"
import script from "./ViewPerson.vue?vue&type=script&lang=js"
export * from "./ViewPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports